var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.domainObjects),function(domainObject){return _c('div',{key:domainObject.type},[(domainObject.visible)?_c('b-dropdown',{attrs:{"variant":"primary","id":domainObject.type,"text":_vm.$t(
          domainObject.type === 'email' &&
            _vm.custom.nonWhitelistedEmailAddressesAllowed
            ? 'emailNonWhitelisted'
            : domainObject.type + 'Text'
        )}},_vm._l((domainObject.domains),function(domain){return _c('b-dropdown-item-button',{key:domain},[_vm._v(" "+_vm._s(domain.name)+" ")])}),1):_vm._e(),(domainObject.visible && _vm.loadingValidDomains)?[_c('div',{staticClass:"spinner-border spinner-border-sm"})]:_vm._e()],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }